// src/components/pages/ProfileEditPage.js

import React from 'react';
import ProfileSettings from '../organisms/ProfileSettings';

const ProfileEditPage = () => {
  return <ProfileSettings />;
};

export default ProfileEditPage;